import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Header2_ScreenContext } from "../header2/header2-context";

declare let window: any;

export interface IProductSelect_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IProductSelect_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  WriteToLocalStorage: any;
  WriteToLocalStorage_dummy: any;
  ReadFromLocalStorage: string;
  ReadFromLocalStorage_dummy: string;
  GetProductHeader: any[];
  GetProductHeader_dummy: any[];
  GetSelectCustomer: any[];
  GetSelectCustomer_dummy: any[];
  BadgerCount: any[];
  BadgerCount_dummy: any[];
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  SetValueOf: any;
  SetValueOf_dummy: any;
  GetItemCodeByBarcode: any[];
  GetItemCodeByBarcode_dummy: any[];
  Notify: boolean;
  Notify_dummy: boolean;
  ScanBarcode: string;
  ScanBarcode_dummy: string;
  isComp750564Visible: "visible" | "hidden";
  isComp881970Visible: "visible" | "hidden";
  isComp614505Visible: "visible" | "hidden";
  isComp242765Visible: "visible" | "hidden";
}

export class ProductSelect_ScreenBase extends React.PureComponent<
  IProductSelect_ScreenProps,
  any
> {
  static contextType = Header2_ScreenContext;
  declare context: React.ContextType<typeof Header2_ScreenContext>;
  productselect_13255_value_kuikaTableRef: React.RefObject<any>;
  productselect_129051_value_kuikaPaginationRef: React.RefObject<any>;
  ml = [
    {
      Id: "70da2015-72e4-4a73-bc3e-b700175ae3a3",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "4490743f-3366-4417-8da3-28c20f6d44d7",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 725363, PropertyName: "value", Value: "Bırak" },
        { Id: 679517, PropertyName: "placeholder", Value: "Ürün Ara..." },
        {
          Id: 414393,
          PropertyName: "placeholder",
          Value: "Barcode giriniz veya okutunuz",
        },
        { Id: 812770, PropertyName: "value", Value: "Ürünler" },
        { Id: 820957, PropertyName: "title", Value: "Title" },
        {
          Id: 911761,
          PropertyName: "value",
          Value: "[datafield:productdescription]",
        },
        { Id: 249346, PropertyName: "value", Value: "[datafield:productcode]" },
        { Id: 614505, PropertyName: "value", Value: "Stokta" },
        { Id: 242765, PropertyName: "value", Value: "Stokta Yok" },
        { Id: 770162, PropertyName: "value", Value: "[datafield:price]" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.productselect_679517_value_kuikaTextInputRef = React.createRef();
    this.productselect_414393_value_kuikaTextInputRef = React.createRef();
    this.productselect_13255_value_kuikaTableRef = React.createRef();
    this.productselect_129051_value_kuikaPaginationRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      WriteToLocalStorage: "",
      ReadFromLocalStorage: "",
      GetProductHeader: [],
      GetSelectCustomer: [],
      BadgerCount: [],
      NAVIGATE: "",
      SetValueOf: "",
      GetItemCodeByBarcode: [],
      Notify: false,
      ScanBarcode: "",
      isComp750564Visible: "hidden",
      isComp881970Visible: "hidden",
      isComp614505Visible: "hidden",
      isComp242765Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "productselect",
        "header2_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.ProductSelectPageInit();
    } else if (this.context?.isMasterPageInitLoaded) {
      this._prevMasterPageInitLoaded = true;
      await this.ProductSelectPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "productselect",
      "header2_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "productselect",
      "header2_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.ProductSelectPageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.ProductSelectPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  ProductSelectPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.WriteToLocalStorage =
      await ReactSystemFunctions.writeToLocalStorage(
        ReactSystemFunctions.convertToTypeByName("CartHeaderId", "string"),
        this.props.screenInputs.CartHeaderId ??
          this.props.screenInputs.cartheaderid
      );
    stateVars.ReadFromLocalStorage =
      await ReactSystemFunctions.readFromLocalStorage(
        ReactSystemFunctions.convertToTypeByName("CartHeaderId", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProductSelectPageInit1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  ProductSelectPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      SearchText_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      CartHeaderId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      ),
      CartHeaderId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ProductSelect/ProductSelectPageInit1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetProductHeader = result?.data.getProductHeader;

    stateVars.GetSelectCustomer = result?.data.getSelectCustomer;
    formVars.productselect_460144_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetSelectCustomer !== undefined
        ? stateVars.GetSelectCustomer?.length > 0
          ? stateVars.GetSelectCustomer[0].curAccCode
          : null
        : this.state.GetSelectCustomer?.length > 0
        ? this.state.GetSelectCustomer[0].curAccCode
        : null
    );
    formVars.productselect_184729_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetSelectCustomer !== undefined
        ? stateVars.GetSelectCustomer?.length > 0
          ? stateVars.GetSelectCustomer[0].customerName
          : null
        : this.state.GetSelectCustomer?.length > 0
        ? this.state.GetSelectCustomer[0].customerName
        : null
    );
    formVars.productselect_357781_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetSelectCustomer !== undefined
        ? stateVars.GetSelectCustomer?.length > 0
          ? stateVars.GetSelectCustomer[0].customerPhone
          : null
        : this.state.GetSelectCustomer?.length > 0
        ? this.state.GetSelectCustomer[0].customerPhone
        : null
    );
    stateVars.isComp750564Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSelectCustomer !== undefined
            ? stateVars.GetSelectCustomer?.length > 0
              ? stateVars.GetSelectCustomer[0].cartHeaderId
              : null
            : this.state.GetSelectCustomer?.length > 0
            ? this.state.GetSelectCustomer[0].cartHeaderId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.BadgerCount = result?.data.badgerCount;
    formVars.productselect_134586_count = ReactSystemFunctions.toString(
      this,
      stateVars.BadgerCount !== undefined
        ? stateVars.BadgerCount?.length > 0
          ? stateVars.BadgerCount[0].toplamAdet
          : null
        : this.state.BadgerCount?.length > 0
        ? this.state.BadgerCount[0].toplamAdet
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProductSelectPageInit2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProductSelectPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.isComp750564Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSelectCustomer !== undefined
            ? stateVars.GetSelectCustomer?.length > 0
              ? stateVars.GetSelectCustomer[0].cartHeaderId
              : null
            : this.state.GetSelectCustomer?.length > 0
            ? this.state.GetSelectCustomer[0].cartHeaderId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.productselect_460144_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetSelectCustomer !== undefined
        ? stateVars.GetSelectCustomer?.length > 0
          ? stateVars.GetSelectCustomer[0].curAccCode
          : null
        : this.state.GetSelectCustomer?.length > 0
        ? this.state.GetSelectCustomer[0].curAccCode
        : null
    );

    formVars.productselect_184729_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetSelectCustomer !== undefined
        ? stateVars.GetSelectCustomer?.length > 0
          ? stateVars.GetSelectCustomer[0].customerName
          : null
        : this.state.GetSelectCustomer?.length > 0
        ? this.state.GetSelectCustomer[0].customerName
        : null
    );

    formVars.productselect_357781_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetSelectCustomer !== undefined
        ? stateVars.GetSelectCustomer?.length > 0
          ? stateVars.GetSelectCustomer[0].customerPhone
          : null
        : this.state.GetSelectCustomer?.length > 0
        ? this.state.GetSelectCustomer[0].customerPhone
        : null
    );

    formVars.productselect_134586_count = ReactSystemFunctions.toString(
      this,
      stateVars.BadgerCount !== undefined
        ? stateVars.BadgerCount?.length > 0
          ? stateVars.BadgerCount[0].toplamAdet
          : null
        : this.state.BadgerCount?.length > 0
        ? this.state.BadgerCount[0].toplamAdet
        : null
    );

    stateVars.dataSource_13255 =
      stateVars.GetProductHeader ?? this.state.GetProductHeader;
    stateVars.isComp614505Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "productselect_13255_value",
          "hasStock"
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp242765Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "productselect_13255_value",
          "hasStock"
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.productselect_129051_total = ReactSystemFunctions.value(
      this,
      stateVars.GetProductHeader !== undefined
        ? stateVars.GetProductHeader?.length > 0
          ? stateVars.GetProductHeader[0].totalRowCount
          : null
        : this.state.GetProductHeader?.length > 0
        ? this.state.GetProductHeader[0].totalRowCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  ProductSelectComponent_548817_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/customerselect") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "ProductSelect",
      "CustomerSelect",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProductSelectComponent_679517_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      SearchText_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "productselect_679517_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ProductSelect/ProductSelectComponent_679517_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetProductHeader = result?.data.getProductHeader;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProductSelectComponent_679517_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProductSelectComponent_679517_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "productselect_129051_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );

    stateVars.dataSource_13255 =
      stateVars.GetProductHeader ?? this.state.GetProductHeader;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProductSelectComponent_414393_onBlur = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Barcode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "productselect_414393_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ProductSelect/ProductSelectComponent_414393_onBlur",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetItemCodeByBarcode = result?.data.getItemCodeByBarcode;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProductSelectComponent_414393_onBlur1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProductSelectComponent_414393_onBlur1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.toString(
        this,
        stateVars.GetItemCodeByBarcode !== undefined
          ? stateVars.GetItemCodeByBarcode?.length > 0
            ? stateVars.GetItemCodeByBarcode[0].message
            : null
          : this.state.GetItemCodeByBarcode?.length > 0
          ? this.state.GetItemCodeByBarcode[0].message
          : null
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      2,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProductSelectComponent_414393_onBlur2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  ProductSelectComponent_414393_onBlur2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetItemCodeByBarcode !== undefined
            ? stateVars.GetItemCodeByBarcode?.length > 0
              ? stateVars.GetItemCodeByBarcode[0].success
              : null
            : this.state.GetItemCodeByBarcode?.length > 0
            ? this.state.GetItemCodeByBarcode[0].success
            : null
        ),
        true
      )
    ) {
      KuikaAppManager.prepareForNavigation();
      KuikaAppManager.addToPageInputVariables(
        "AddBasketBarcodePopUp",
        "ItemCode",
        ReactSystemFunctions.convertToTypeByName(
          ReactSystemFunctions.toString(
            this,
            stateVars.GetItemCodeByBarcode !== undefined
              ? stateVars.GetItemCodeByBarcode?.length > 0
                ? stateVars.GetItemCodeByBarcode[0].itemCode
                : null
              : this.state.GetItemCodeByBarcode?.length > 0
              ? this.state.GetItemCodeByBarcode[0].itemCode
              : null
          ),
          "string"
        )
      );
      KuikaAppManager.addToPageInputVariables(
        "AddBasketBarcodePopUp",
        "CartHeaderId",
        ReactSystemFunctions.convertToTypeByName(
          this.props.screenInputs.CartHeaderId ??
            this.props.screenInputs.cartheaderid,
          "Guid"
        )
      );

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        undefined,
        "ProductSelect",
        "AddBasketBarcodePopUp",
        "",
        "9924ef5f-4b84-4200-b624-8d76348c7686",
        "811113",
        null,
        null,
        "true",
        "100%",
        "400px",
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  ProductSelectComponent_328068_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ScanBarcode = await ReactSystemFunctions.scanBarcode();

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProductSelectComponent_328068_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  ProductSelectComponent_328068_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Barcode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.ScanBarcode),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ProductSelect/ProductSelectComponent_328068_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetItemCodeByBarcode = result?.data.getItemCodeByBarcode;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProductSelectComponent_328068_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProductSelectComponent_328068_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.toString(
        this,
        stateVars.GetItemCodeByBarcode !== undefined
          ? stateVars.GetItemCodeByBarcode?.length > 0
            ? stateVars.GetItemCodeByBarcode[0].message
            : null
          : this.state.GetItemCodeByBarcode?.length > 0
          ? this.state.GetItemCodeByBarcode[0].message
          : null
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      2,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProductSelectComponent_328068_onClick3_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  ProductSelectComponent_328068_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetItemCodeByBarcode !== undefined
            ? stateVars.GetItemCodeByBarcode?.length > 0
              ? stateVars.GetItemCodeByBarcode[0].success
              : null
            : this.state.GetItemCodeByBarcode?.length > 0
            ? this.state.GetItemCodeByBarcode[0].success
            : null
        ),
        true
      )
    ) {
      KuikaAppManager.prepareForNavigation();
      KuikaAppManager.addToPageInputVariables(
        "AddBasketBarcodePopUp",
        "ItemCode",
        ReactSystemFunctions.convertToTypeByName(
          ReactSystemFunctions.toString(
            this,
            stateVars.GetItemCodeByBarcode !== undefined
              ? stateVars.GetItemCodeByBarcode?.length > 0
                ? stateVars.GetItemCodeByBarcode[0].itemCode
                : null
              : this.state.GetItemCodeByBarcode?.length > 0
              ? this.state.GetItemCodeByBarcode[0].itemCode
              : null
          ),
          "string"
        )
      );
      KuikaAppManager.addToPageInputVariables(
        "AddBasketBarcodePopUp",
        "CartHeaderId",
        ReactSystemFunctions.convertToTypeByName(
          ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
          "Guid"
        )
      );

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        undefined,
        "ProductSelect",
        "AddBasketBarcodePopUp",
        "",
        "9924ef5f-4b84-4200-b624-8d76348c7686",
        "943583",
        null,
        null,
        "true",
        "100%",
        "400px",
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  ProductSelectComponent_23250_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/productbasket") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "ProductBasket",
      "CartHeaderId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "ProductSelect",
      "ProductBasket",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProductSelectComponent_98595_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/productdetail") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "ProductDetail",
      "ItemCode",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "productselect_13255_value",
          "productCode"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "ProductDetail",
      "CartHeaderId",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CartHeaderId ??
          this.props.screenInputs.cartheaderid,
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "ProductSelect",
      "ProductDetail",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProductSelectComponent_576258_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "AddBasketPopUp",
      "ItemId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "productselect_13255_value", "id"),
        "Guid"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "AddBasketPopUp",
      "CardHeaderId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "ProductSelect",
      "AddBasketPopUp",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "576407",
      null,
      null,
      "true",
      "100%",
      "400px",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProductSelectComponent_129051_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      SearchText_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "productselect_679517_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "productselect_129051_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ProductSelect/ProductSelectComponent_129051_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetProductHeader = result?.data.getProductHeader;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProductSelectComponent_129051_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProductSelectComponent_129051_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_13255 =
      stateVars.GetProductHeader ?? this.state.GetProductHeader;
    formVars.productselect_129051_total = ReactSystemFunctions.value(
      this,
      stateVars.GetProductHeader !== undefined
        ? stateVars.GetProductHeader?.length > 0
          ? stateVars.GetProductHeader[0].totalRowCount
          : null
        : this.state.GetProductHeader?.length > 0
        ? this.state.GetProductHeader[0].totalRowCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [, 811113, 943583, , , 576407] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.ProductSelectPageInit();
    }
  }
}
